module.exports = __webpack_public_path__ + "static/media/escaner-modo-almacen-limpiar-datos.b6cee55b.png";